
import { limitString, capitalizeUnitName } from '~/fc/helpers'

export default {
  name: 'UnitFormula',
  components: {
    ButtonCopy: () => import(/* webpackChunkName: "ButtonCopy" */ '../../../components/ui/form/buttons/ButtonCopy')
  },
  props: {
    // eslint-disable-next-line vue/require-prop-types
    formula: {
      default: '',
      required: true
    }
  },
  computed: {
    isMobile () { return this.$store.state.store.isMobile },
    info () { return this.$store.state.info },
    sourceName () { return capitalizeUnitName(this.info.source, 'name_plural') },
    targetName () { return capitalizeUnitName(this.info.target, 'name_plural') },
  },
  methods: {
    limitString (s, n) {
      return limitString(s, n)
    },
    capitalizeUnitName (unit, name) {
      capitalizeUnitName(unit, name)
    }
  }
}
